import * as React from "react";
import { styled, OutlinedInput, SxProps } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

export interface SearchExpandProps {
  sx?: SxProps;
  onChange?: (pattern: string) => void;
}

const SearchExpand: React.FC<SearchExpandProps> = (props) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState("");

  const onChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback((e) => {
    setValue(e.currentTarget.value);
    if (props.onChange) props.onChange(e.currentTarget.value);
  }, []);

  return (
    <SearchInput
      sx={props.sx}
      value={value}
      onChange={onChange}
      label={t("common:standard")}
      placeholder={t("common:placeholder")}
      size="small"
      endAdornment={<SearchIcon htmlColor="text.primary" />}
    />
  );
};

export default SearchExpand;

export const SearchInput = styled(OutlinedInput)<{ value: string }>(({ theme, value }) => ({
  paddingRight: 0,
  svg: {
    position: "absolute",
    right: theme.spacing(1),
    pointerEvents: "none",
    color: theme.palette.primary.text,
  },
  ".MuiInputBase-input": {
    width: 16,
    transition: "width .15s  cubic-bezier(0.65, 0, 0.35, 1), paddingRight .15s  cubic-bezier(0.65, 0, 0.35, 1)",
    "&::placeholder": {
      opacity: 0,
    },
    "&:focus": {
      width: 200,
      paddingRight: theme.spacing(4),
      "&:placeholder": {
        opacity: 0,
      },
    },
    ...(value.length > 0 && {
      width: 200,
      paddingRight: theme.spacing(4),
      "&:placeholder": {
        opacity: 0,
      },
    }),
  },
}));
